export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            'url(https://readdy.ai/api/search-image?query=modern%20industrial%20factory%20production%20line%20with%20advanced%20machinery%20and%20control%20panels%20in%20dramatic%20lighting%20with%20dark%20blue%20and%20gray%20tones%20creating%20professional%20atmosphere%20high%20tech%20manufacturing%20facility%20interior&width=1920&height=1080&seq=hero-bg-001&orientation=landscape)',
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 text-center text-white w-full py-16 sm:py-20">
        <div className="inline-block bg-red-600/90 px-4 sm:px-6 py-1.5 sm:py-2 rounded-full mb-3 sm:mb-5">
          <p className="text-[10px] sm:text-sm font-semibold whitespace-nowrap">
            工場・産業用 BCP（事業継続計画）対策ソリューション
          </p>
        </div>

        <h1 className="text-3xl sm:text-5xl md:text-6xl font-bold mb-3 sm:mb-4" style={{ lineHeight: '1.5' }}>
          ボヤ騒ぎで数千万円の
          <br />
          ラインを止めるな
        </h1>

        <div className="space-y-2 sm:space-y-3 mb-4 sm:mb-6">
          <p className="text-base sm:text-xl md:text-2xl font-medium">
            その「粉末消火器」を使った瞬間、機械は故障し、納期は遅延します。
          </p>
          <p className="text-base sm:text-xl md:text-2xl font-medium">
            「汚さない」次世代消火具で、最短即時の操業復旧を。
          </p>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-6 mb-5 sm:mb-6">
          <div className="flex items-center space-x-1.5 sm:space-x-3 bg-yellow-400/20 backdrop-blur-sm border border-yellow-400/50 px-3 sm:px-6 py-1.5 sm:py-3 rounded-full">
            <i className="ri-award-line text-base sm:text-3xl text-yellow-400"></i>
            <span className="text-xs sm:text-lg font-bold whitespace-nowrap tracking-wide">台湾シェアNo.1</span>
          </div>
          <div className="flex items-center space-x-1.5 sm:space-x-3 bg-green-400/20 backdrop-blur-sm border border-green-400/50 px-3 sm:px-6 py-1.5 sm:py-3 rounded-full">
            <i className="ri-shield-check-line text-base sm:text-3xl text-green-400"></i>
            <span className="text-xs sm:text-lg font-bold whitespace-nowrap tracking-wide">総務省消防庁 届出済</span>
          </div>
        </div>

        <a
          href="https://fireout.stores.jp/inquiry"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block bg-red-600 text-white px-8 sm:px-14 py-3.5 sm:py-5 rounded-full text-sm sm:text-xl font-bold hover:bg-red-700 transition-all transform hover:scale-105 shadow-2xl whitespace-nowrap cursor-pointer"
        >
          無料お見積り・導入のご相談
        </a>
      </div>

      <div className="absolute bottom-4 sm:bottom-6 w-full flex justify-center animate-bounce">
        <i className="ri-arrow-down-line text-3xl sm:text-4xl text-white/80"></i>
      </div>
    </section>
  );
}